module.exports = __webpack_public_path__ + "img/ic-nav-tuktuk--next--pink.4ee09cea.svg";